import { useQuery } from '@apollo/client';
import { Box } from '@mui/material';
import { styled } from '@mui/styles';
import Loader from 'Components/Forms/Loader';
import SearchToolbar from 'Components/Forms/SearchToolbar';
import { GET_ALL_PRODUCTS } from 'graphql/secure/queries';
import React, { Fragment, useMemo, useState } from 'react';
import { IProduct } from 'FeatureModules/ProductPage/types/product.types';
import { IGraphQlConnection } from 'types/core.types';
import { filterItems } from 'utils/sortTable.utils';
import SelectProductTable from 'FeatureModules/ProductPage/Components/Tables/SelectProductTable';
import EmptySearch from 'Components/EmptySearch';
import ErrorState from 'Components/ErrorState';

const SearchbarContainer = styled(Box)(() => ({
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  top: -35,
  left: 0,
  zIndex: 9,
}));

interface IProps {
  selectedProductId?: IProduct['id'];
  setSelectedProductId: (productId: IProduct['id']) => void;
}

const ProductSelector: React.FC<IProps> = ({ selectedProductId, setSelectedProductId }) => {
  const { data, loading, error } = useQuery<{ products: IGraphQlConnection<IProduct> }>(
    GET_ALL_PRODUCTS
  );
  const products = useMemo(() => data?.products.edges || [], [data]);

  const [searchTerm, setSearchTerm] = useState('');

  const filteredProducts = useMemo(() => {
    return filterItems(products, searchTerm);
  }, [products, searchTerm]);

  if (error) return <ErrorState />;
  else if (!products && loading) return <Loader />;

  return (
    <Fragment>
      <Box position="relative" mt={7} mb={3}>
        <SearchbarContainer>
          <SearchToolbar
            setSearchTerm={setSearchTerm}
            searchTerm={searchTerm}
            data-testid="document-search-input"
            placeholder="Search products"
            className="search-input"
          />
        </SearchbarContainer>
        <SelectProductTable
          products={filteredProducts}
          selectedProductId={selectedProductId}
          setSelectedProductId={setSelectedProductId}
        />
      </Box>
      {!filteredProducts.length && <EmptySearch />}
    </Fragment>
  );
};

export default ProductSelector;
